function getSocialCampaign(messages, orgName, hostedButtonId, socialTitle) {
  const {
    emailSubject = '',
    emailBody = '',
    mobileText = '',
    facebookMessage = '',
    twitterMessage = '',
    whatsappMessage = '',
    copyLinkHeader = '',
    copyLinkSubheader = '',
    copyText = '',
    copiedText = '',
  } = messages || {};

  const hostedButtonUrl = `https://paypal.com/donate?cmd=_s-xclick&hosted_button_id=${hostedButtonId}&source=url`;

  const socialCampaign = {
    email: true,
    emailSubject: emailSubject.replace('{donationName}', orgName),
    emailBody: encodeURIComponent(
      emailBody
        .replace(new RegExp('<br>', 'g'), '\r\n')
        .replace('{donationName}', orgName)
        .replace('{url}', hostedButtonUrl)
    ),
    mobile: true,
    mobileTitle: emailSubject.replace('{donationName}', orgName),
    mobileText: mobileText.replace('{donationName}', orgName),
    facebook: true,
    facebookMessage: facebookMessage.replace('{donationName}', orgName),
    facebookMessenger: true,
    whatsapp: true,
    whatsappMessage: encodeURIComponent(
      whatsappMessage
        .replace(new RegExp('<br>', 'g'), '\r\n')
        .replace('{donationName}', orgName)
    ),
    twitter: true,
    twitterMessage: twitterMessage.replace('{donationName}', orgName),
    copyLink: true,
    copyLinkHeader,
    copyLinkSubheader,
    copyLinkCopy: copyText,
    copyLinkCopied: copiedText,
    title: socialTitle,
  };

  return socialCampaign;
}

export default getSocialCampaign;
